import {Field} from 'formik';

const FormikRadioButtons = ({title, options, name}: IFormikRadioButtons) => {
  return (
    <>
      <p className="text-gray-6 font-extrabold">{title}</p>
      <div>
        {options.map((item, index) => (
          <p className="my-3 ">
            <Field
              type="radio"
              name={name}
              value={item.value}
              className="mx-2"
              key={index}
            />
            {item.label}
          </p>
        ))}
      </div>
    </>
  );
};

export default FormikRadioButtons;
